// Hide "Starting at" text when any product option changes
document.addEventListener('DOMContentLoaded', function() {
    // Function to hide the starting at text
    function hideStartingAtText() {
        try {
            const startingAtElements = document.querySelectorAll('.starting-at');
            if (startingAtElements && startingAtElements.length > 0) {
                startingAtElements.forEach(element => {
                    if (element) {
                        element.style.display = 'none';
                    }
                });
            }
        } catch (error) {
            // Silently handle any errors to prevent console errors
            console.warn('Could not hide starting-at text:', error);
        }
    }
    
    // Listen for changes on all product custom option select fields
    document.addEventListener('change', function(e) {
        try {
            if (e.target && e.target.classList && e.target.classList.contains('product-custom-option')) {
                hideStartingAtText();
            }
        } catch (error) {
            // Silently handle any errors
            console.warn('Error handling change event:', error);
        }
    });
    
    // Also listen for input events on text fields for real-time response
    document.addEventListener('input', function(e) {
        try {
            if (e.target && e.target.classList && e.target.classList.contains('product-custom-option')) {
                hideStartingAtText();
            }
        } catch (error) {
            // Silently handle any errors
            console.warn('Error handling input event:', error);
        }
    });
});
